import NEW_BOOKING_STEPS from 'constants/vetUnityNewBookingSteps';

const PRIVATE_CREMATION = Object.freeze({
    ownerPetDetails: NEW_BOOKING_STEPS.ownerPetDetails,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default PRIVATE_CREMATION;
